import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"
import { takeLatest, call, select, put } from "redux-saga/effects"
import { post as postApi } from "api"
import { Creators as notificationCreators } from "modules/notifications/model"
import { Creators as modelCreators } from "model/data"
import { size } from "lodash"

export const { Types, Creators } = actionCreator("ompnt/modules/eze/", {
  importPortfolios: {
    props: ["ezePortfolioIds"],
    track: true,
    trackType: "eze-portfolios-import",
    trackPayload: ({ ezePortfolioIds }) => ({ portfoliosCount: size(ezePortfolioIds) }),
  },
  importPortfoliosSuccess: [],
})

const INITIAL_STATE = {
  importing: false,
  authenticated: false,
  portfolios: {
    loading: false,
    items: [],
  },
}

function handleImportPortfolios(state) {
  return { ...state, importing: true }
}

function handleImportPortfoliosSuccess(state) {
  return { ...state, importing: false }
}

export const HANDLERS = {
  [Types.IMPORT_PORTFOLIOS]: handleImportPortfolios,
  [Types.IMPORT_PORTFOLIOS_SUCCESS]: handleImportPortfoliosSuccess,
}

export default createReducer(INITIAL_STATE, HANDLERS)

export function* importPortfolios({ ezePortfolioIds }) {
  const { account } = yield select(state => ({
    account: state.global.selected.account,
  }))

  try {
    yield call(postApi, `/api/${account}/eze/import`, { ezePortfolioIds })
    yield put(modelCreators.resetCollections(["benchmarksAndPortfolios", "accountPortfolios", "portfolios", "ezeMetadata", "ezePortfolios", "notifications"]))
    yield put({ type: Types.IMPORT_PORTFOLIOS_SUCCESS })
  } catch {
    yield put(notificationCreators.add("error", null, "An unexpected error occured while importing portfolios from Eze."))
  }
}

export function* saga() {
  yield takeLatest(Types.IMPORT_PORTFOLIOS, importPortfolios)
}
